import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "this-text" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "formBody" };
const _hoisted_7 = { class: "this-actions" };
import { ThemeFormField, ThemeModal, ThemeButton } from '../';
import { onMounted, ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SrcLinkModalApp',
    props: {
        srcTitle: {},
        setSkipModal: { type: Function },
        destroy: { type: Function },
        navigateForward: { type: Function },
        browsingRestrictions: {}
    },
    setup(__props) {
        const props = __props;
        const skipNextTime = ref(false);
        const modal = ref(null);
        let dismissedWithNav = false;
        onMounted(() => {
            var _a;
            (_a = modal.value) === null || _a === void 0 ? void 0 : _a.show();
        });
        watch(skipNextTime, () => {
            props.setSkipModal(skipNextTime.value);
        });
        function dismiss(withNav = false) {
            var _a;
            (_a = modal.value) === null || _a === void 0 ? void 0 : _a.dismiss();
            dismissedWithNav = withNav;
        }
        function onAfterDismissed() {
            if (dismissedWithNav) {
                props.navigateForward();
            }
            props.destroy();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ThemeModal), {
                class: "articleSrcLink-modal",
                title: "Upplysning",
                ref_key: "modal",
                ref: modal,
                onDismissed: _cache[3] || (_cache[3] = ($event) => (onAfterDismissed()))
            }, {
                default: _withCtx(() => {
                    var _a;
                    return [
                        _createElementVNode("p", _hoisted_1, [
                            ((_a = _ctx.browsingRestrictions) === null || _a === void 0 ? void 0 : _a.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[4] || (_cache[4] = _createTextVNode(" Du är på väg att lämna sidan. Artiklar hos ")),
                                    (_ctx.srcTitle)
                                        ? (_openBlock(), _createElementBlock("em", _hoisted_2, _toDisplayString(_ctx.srcTitle), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_3, "där")),
                                    _cache[5] || (_cache[5] = _createTextVNode(" kan vara låsta och kräva prenumeration eller inlogg. "))
                                ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[6] || (_cache[6] = _createTextVNode(" Du är på väg att lämna sidan för att läsa en artikel ")),
                                    (_ctx.srcTitle)
                                        ? (_openBlock(), _createElementBlock("em", _hoisted_4, "hos " + _toDisplayString(_ctx.srcTitle), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_5, "på annan websida")),
                                    _cache[7] || (_cache[7] = _createTextVNode(". Länken kommer att öppnas i en ny flik. "))
                                ], 64))
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(ThemeFormField), {
                                type: "checkbox",
                                "container-class": "this-checkbox",
                                label: "Jag vill i fortsättningen inte se dessa meddelanden.",
                                modelValue: skipNextTime.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((skipNextTime).value = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_unref(ThemeButton), {
                                title: "Skicka mig vidare",
                                fill: "solid",
                                color: "gray",
                                icon: "external-resource",
                                variation: "chip",
                                onClick: _cache[1] || (_cache[1] = ($event) => (dismiss(true)))
                            }),
                            _createVNode(_unref(ThemeButton), {
                                title: "Stäng",
                                color: "gray",
                                fill: "outline",
                                variation: "chip",
                                onClick: _cache[2] || (_cache[2] = ($event) => (dismiss()))
                            })
                        ])
                    ];
                }),
                _: 1
            }, 512));
        };
    }
});
